<template>
    <div id="settings-notifications" class="card">
        <div class="ado-settings__title">
            <i class="fas fa-inbox"></i> Notifications
        </div>
        <div class="card-body">
            <i class="far fa-user-hard-hat"></i> Under construction...
        </div>
    </div>
</template>

<script>
export default {
    name: 'settings-notifications'
}
</script>